import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'connected-react-router';
import { composeWithDevTools } from 'redux-devtools-extension';

import api from './middleware/api';
import cTaskAnswer from './middleware/cTaskAnswer';

import reducer from './reducer';
import history from '../history';

const enhancer = applyMiddleware(thunk, routerMiddleware(history), api, cTaskAnswer);
const composeEnhancers = composeWithDevTools({ trace: true, traceLimit: 25});

const store = createStore(reducer, composeEnhancers(enhancer));

export default store;
